module.exports = __webpack_public_path__ + "img/vertical_4_5_9005.cd419cba.png";